var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('HeaderContent'),_c('v-main',[_c('MainContent',{staticClass:"ml-3 mb-3"})],1),_c('v-footer',{attrs:{"app":"","padless":"","color":"#fff"}},[_c('FooterContent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }